import { Page } from 'components/Page/Page';
import * as React from 'react';
import { UnsupportedMessage } from './UnsupportedMessage';

export const UnsupportedRegion: React.FC = () => {
  return (
    <Page className="p-16 pt-8">
      <UnsupportedMessage />
    </Page>
  );
};
UnsupportedRegion.displayName = 'UnsupportedRegion';
